// ----------------------------------------------------------------------------
// Nombre del Programa : refreshToken
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza para refrescar el token de al api de google identity
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import { setToken,getApiCliGoo,getApiKe } from './session';
import axios, { AxiosRequestHeaders } from 'axios';

const clientId = getApiCliGoo();
const apiKe = getApiKe();

const getRefreshToken = (codeResponse, setEmailUser) => {
    // get refresh token using authorization code
    let payload = {
      grant_type: 'authorization_code',
      code: codeResponse.code,
      client_id: clientId,
      client_secret: apiKe
    };

    axios
      .post(`https://oauth2.googleapis.com/token`, payload, {
        headers: {
          'Content-Type': 'application/json;',
        },
      })
      .then((res: any) => {
        return res.data;
      })
      .then((response: any) => {
        setEmailUser(response);
      })
      .catch((err) => console.log('err: ', err));
  };

  const getNewAccessToken = (token : any) => {
    // get new access token using refresh token
    let payloadForAccessToken = {
      grant_type: 'refresh_token',
      refresh_token: token,
      client_id: clientId,
      client_secret: apiKe
    };

    axios
      .post(`https://oauth2.googleapis.com/token`, payloadForAccessToken, {
        headers: {
          'Content-Type': 'application/json;',
        },
      })
      .then((res: any) => {
        return res.data;
      })
      .then((res) => {
        console.log('new token response: ', res);
      })
      .catch((err) => console.log('err: ', err));
  };

const refreshTokenSetup = (res: any) => {//access_token
    let refreshTiming = (res.expires_in || 3600 - 5 * 60) * 1000;
    const refreshToken = async () => {
        const newAuthRes = await res.getNewAccessToken(res.access_token);
        refreshTiming = (newAuthRes.expires_in || 3600 - 5 * 60) * 1000;

        setToken(newAuthRes.access_token);

        setTimeout(refreshToken, refreshTiming);
    }
    setTimeout(refreshToken, refreshTiming);
}

export  { refreshTokenSetup, getNewAccessToken,getRefreshToken };